$("div#stamped-reviews-widget").click(function() {
    $('html,body').animate({
        scrollTop: $(".product-reviews").offset().top},
        'slow');
});


$(window).load(function() {
     var insta_img = $('div#instafeed a img').width();
  $('div#instafeed a').css('max-height', insta_img); 
    });

$( window ).resize(function() {
       var insta_img = $('div#instafeed a img').width();
 $('div#instafeed a').css('max-height', insta_img); 
    });

// for product page video height manage

if($(window).width() <= 767){
  var p_video_width =  $(".product-video-section iframe").width();
  var p_video_height = (p_video_width * 70)/100;
  $(".product-video-section iframe").height(p_video_height);
}



// // annoument header sticky
// $(window).scroll(function(){
// $('.announcement-bar').addClass('fixed-sticky');
// });
//  $(window).scrollTop(function(){
// $('.announcement-bar').removeClass('fixed-sticky');
// });



$(window).scroll(function() {    
    var scroll = $(window).scrollTop();

    if (scroll >= 500) {
       $('.announcement-bar').addClass('fixed-sticky');
    } else {
      $('.announcement-bar').removeClass('fixed-sticky');
    }
});
// routine page image change
$(document).ready(function(){
  $("ul.routine-page__featured-product--thumbnails li").click(function(){
    $(this).addClass('active').siblings().removeClass('active');
    var img_url_thum =$(this).find("img").attr("src");
    $(".routine-page__featured-product-image--main img").attr("src",img_url_thum);
  });
});